// @flow
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';
import { UserContext } from 'contexts/UserContext';
import { useQuery } from 'react-query';
import useAbortController from 'hooks/useAbortController';
import { getHouseholdMemberStatus } from 'services/userService';
import QUERY_KEYS from 'constants/queryKeys';

const useHouseholdMemberStatusQuery = () => {
  const { organizationId, propertyId } = useContext(AppContext);
  const {
    userProfile: { customerId, householdId },
  } = useContext(UserContext);
  const abortControllerOptions = useAbortController();

  return useQuery(
    QUERY_KEYS.householdMemberStatus({
      organizationId,
      propertyId,
      customerId,
      householdId,
    }),
    () =>
      getHouseholdMemberStatus(
        {
          organizationId,
          propertyId,
          customerId,
          householdId,
        },
        abortControllerOptions,
      ),
    {
      enabled: Boolean(
        organizationId?.length &&
          propertyId?.length &&
          customerId?.length &&
          householdId?.length,
      ),
    },
  );
};

export default useHouseholdMemberStatusQuery;
